import React, { useEffect, useState } from "react";
// import { useAuth } from "../../contexts/AuthContext";
import { motion } from 'framer-motion';
import { Mail, Lock, Eye, EyeOff, User, UserPlus, AlertCircle, Loader2, CheckCircle, XCircle, } from 'lucide-react';
import { checkLoginStatus, registerUser, checkUsernameAvailability, checkEmailAvailability, loginUser } from "../../api/authService";
import { Toast } from "../../components/Toast";
import Link from '../../components/Link';

export default function SignupPage() {
  // const { signup } = useAuth();
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState(false);
  const [bookId, setBookID] = useState(null);
  const [formData, setFormData] = useState({
    email: '',
    password: '',
    confirmPassword: '',
    display_name: '',
    isUsernameAvailable: false,
    isEmailAvailable: false
  });
  const [isLoading, setIsLoading] = useState(false);

  const checkifLinkHasID = () => {
    const searchParams = new URLSearchParams(window.location.search);
    const id = searchParams.get("id");
    if (!id) {
      return false;
    }
    setBookID(id);
    return id;
  }

  useEffect(() => {
    const verifyUser = async () => {
      const bookID_fromURL = checkifLinkHasID();
      const isAuthenticated = await checkLoginStatus();
      if (isAuthenticated) {
        bookID_fromURL !== false ? window.location.href = `book-detail?id=${bookID_fromURL}` : window.location.href = "/";
      }
    };
    verifyUser();
  }, []);

  const handleChange = (e) => {
    setFormData((prev) => ({
      ...prev,
      [e.target.name]: e.target.value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);

    // Check if passwords match
    if (formData.password !== formData.confirmPassword) {
      Toast.error('Passwords do not match');
      setIsLoading(false);
      return;
    }

    // Check if username and email are available
    if (!formData.isUsernameAvailable) {
      Toast.error('Display name is not available. Please choose another one.');
      setIsLoading(false);
      return;
    }

    if (!formData.isEmailAvailable) {
      Toast.error('Email is already in use. Try logging in.');
      setIsLoading(false);
      return;
    }

    try {
      // Register the user
      const { success, message } = await registerUser({
        email: formData.email,
        password: formData.password,
        username: formData.display_name
      });

      if (!success) throw new Error(message);

      // **Immediately log the user in**
      const loginResponse = await loginUser(formData.display_name, formData.password, bookId);

      if (!loginResponse.success) throw new Error(loginResponse.message);

      // **Store the token and redirect**
      // localStorage.setItem('token', loginResponse.token);
      Toast.success('Registration successful! Please check your email for the verification link to verify your account!');
      // window.location.href = "/";

    } catch (error) {
      Toast.error(error.message || 'Failed to register');
    } finally {
      setIsLoading(false);
    }
  };


  const handleSubmit_ = async (e) => {
    e.preventDefault();

    if (!name || !email || !password || !confirmPassword) {
      setError('Please fill in all fields');
      return;
    }

    if (password !== confirmPassword) {
      setError('Passwords do not match');
      return;
    }

    if (password.length < 6) {
      setError('Password must be at least 6 characters long');
      return;
    }

    setLoading(true);
    setError('');

    // await signup(name, email, password);

    setSuccess(true);

    setLoading(false);
  };



  if (success) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-green-50 via-white to-emerald-50 px-4 sm:px-6 lg:px-8">
        <div className="max-w-md w-full space-y-8">
          <div className="text-center">
            <div className="mx-auto h-16 w-16 bg-gradient-to-r from-green-600 to-emerald-600 rounded-full flex items-center justify-center mb-6">
              <CheckCircle className="h-8 w-8 text-white" />
            </div>
            <h2 className="text-3xl font-bold text-gray-900 mb-2">Account created!</h2>
            <p className="text-sm text-gray-600 mb-6">
              Check your email to verify your account and complete the setup.
            </p>
            <a
              href="/login"
              className="inline-flex items-center px-4 py-2 border border-transparent text-sm font-medium rounded-lg text-white bg-gradient-to-r from-green-600 to-emerald-600 hover:from-green-700 hover:to-emerald-700 transition-colors"
            >
              Continue to Login
            </a>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-red-50 via-white to-pink-50 px-4 sm:px-6 lg:px-8">
      <div className="max-w-md w-full space-y-8">
        {/* Header */}
        <div className="text-center">
          <h2 className="text-3xl font-bold text-gray-900 mb-2">Create your account</h2>
          <p className="text-sm text-gray-600">
            Sign up today, and post your reviews.
          </p>
        </div>

        {/* Form */}
        <div className="bg-white rounded-2xl shadow-xl border border-gray-100 p-8">
          <form onSubmit={handleSubmit} className="space-y-6">
            <DisplayNameInput value={formData.display_name} onChange={handleChange} />

            <EmailInput value={formData.email} onChange={handleChange} />

            <PasswordFields formData={formData} setFormData={setFormData} />

            <button
              type="submit"
              disabled={isLoading || !formData.display_name || !formData.email || !formData.password|| !formData.confirmPassword || !formData.isEmailAvailable || formData.password !== formData.confirmPassword}
              className="w-full flex justify-center items-center py-3 px-4 border border-transparent rounded-lg shadow-sm text-sm font-semibold text-white bg-gradient-to-r from-red-600 to-pink-600 hover:from-red-700 hover:to-pink-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-red-500 disabled:opacity-50 disabled:cursor-not-allowed transition-all duration-200 transform hover:scale-[1.02] active:scale-[0.98]"
            >
              {isLoading ? (
                <>
                  <Loader2 className="h-4 w-4 mr-2 animate-spin" />
                  Creating account...
                </>
              ) : (
                <>
                  <UserPlus className="h-4 w-4 mr-2" />
                  Create account
                </>
              )}
            </button>


            <div className="relative">
              <div className="absolute inset-0 flex items-center">
                <div className="w-full border-t border-gray-300" />
              </div>
              <div className="relative flex justify-center text-sm">
                <span className="px-2 bg-white text-gray-500">or</span>
              </div>
            </div>


            <div className="text-center">
              <p className="text-sm text-gray-600">
                Already have an account?{' '}
                <a href="/login" className="font-medium text-red-600 hover:text-red-500 transition-colors">
                  Sign in instead
                </a>
              </p>
            </div>

            {/* <motion.button
              type="submit"
              disabled={isLoading}
              className="w-full py-3 bg-gradient-to-r from-tc-gold to-orange-600 text-white rounded-lg hover:from-tc-gold hover:to-orange-700 transition-all duration-300 flex items-center justify-center space-x-2"
              whileHover={{ scale: 1.02 }}
              whileTap={{ scale: 0.98 }}
            >
              <UserPlus className="w-5 h-5" />
              <span>{isLoading ? 'Creating account...' : 'Create Account'}</span>
            </motion.button> */}
          </form>



        </div>
      </div>
    </div>
  );
}


const DisplayNameInput = ({ value, onChange }) => {
  const [username, setUsername] = useState(value || ""); // Ensure initial state isn't undefined
  const [isAvailable, setIsAvailable] = useState(null);
  const [suggestions, setSuggestions] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (username.length < 4) {
      setIsAvailable(null);
      setSuggestions([]);
      return;
    }

    const delay = setTimeout(async () => {
      setLoading(true);
      const available = await checkUsernameAvailability(username);
      setIsAvailable(available);
      setLoading(false);

      if (!available) {
        generateSuggestions(username);
      } else {
        setSuggestions([]);
      }
    }, 500);

    return () => clearTimeout(delay);
  }, [username]);

  useEffect(() => {
    updateForm_IsAvailable();
  }, [username, isAvailable]);

  const generateSuggestions = (base) => {
    const randomNumber = () => Math.floor(Math.random() * 1000);
    setSuggestions([
      `${base}${randomNumber()}`,
      `${base}_${randomNumber()}`,
      `${base}${randomNumber()}xyz`,
    ]);
  };

  const handleChange = (e) => {
    const newValue = e.target.value
      .replace(/\s+/g, "_")  // Replace spaces with underscores
      .replace(/[^a-zA-Z0-9_]/g, ""); // Remove all special characters except underscores

    setUsername(newValue);
    onChange({ target: { name: "display_name", value: newValue } });

  };

  const updateForm_IsAvailable = () => {
    if (username.length >= 4 && isAvailable === true) {
      onChange({ target: { name: "isUsernameAvailable", value: true } });
    } else {
      onChange({ target: { name: "isUsernameAvailable", value: false } });
    }
  }

  return (
    <div>
      <label htmlFor="name" className="block text-sm font-medium text-gray-700">
        Username
      </label>
      <div className="relative">
        <User className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400 w-5 h-5" />
        <input
          type="text"
          name="display_name"
          placeholder="Username"
          value={username}
          onChange={handleChange}
          className="block w-full pl-10 pr-3 py-3 border border-gray-300 rounded-lg shadow-sm placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-red-500 focus:border-transparent bg-white hover:border-gray-400 transition-all duration-200"
          required
        />
        {username.length > 0 && username.length < 4 ? (
          <div className="absolute right-3 top-1/2 transform -translate-y-1/2 text-yellow-500">
            Too short!
          </div>
        ) : loading ? (
          <div className="absolute right-3 top-1/2 transform -translate-y-1/2 text-gray-400">Checking...</div>
        ) : isAvailable !== null && (
          <div className="absolute right-3 top-1/2 transform -translate-y-1/2">
            {isAvailable ? (
              <CheckCircle className="text-green-500 w-5 h-5" />
            ) : (
              <XCircle className="text-red-500 w-5 h-5" />
            )}
          </div>
        )}
      </div>

      {username.length >= 4 && !isAvailable && suggestions.length > 0 && (
        <div className="mt-2 text-sm text-gray-400">
          <p className="mb-1">Try one of these:</p>
          <div className="flex space-x-2">
            {suggestions.map((suggestion) => (
              <button
                key={suggestion}
                type="button"
                className="px-3 py-1 bg-gray-700 text-white rounded-lg hover:bg-gray-600 transition-all"
                onClick={() => {
                  setUsername(suggestion);
                  onChange({ target: { name: "display_name", value: suggestion } });
                  setIsAvailable(true);
                  setSuggestions([]);
                }}
              >
                {suggestion}
              </button>
            ))}
          </div>
        </div>
      )}
    </div>
  );
};


const EmailInput = ({ value, onChange }) => {
  const [email, setEmail] = useState(value || "");
  const [isValid, setIsValid] = useState(true);
  const [isAvailable, setIsAvailable] = useState(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!email) {
      setIsValid(true);
      setIsAvailable(null);
      return;
    }

    // Validate email format
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    setIsValid(emailRegex.test(email));

    // If not valid, don't check availability
    if (!emailRegex.test(email)) {
      setIsAvailable(null);
      return;
    }

    // Debounced check for email availability
    const delay = setTimeout(async () => {
      setLoading(true);
      const available = await checkEmailAvailability(email);
      setIsAvailable(available);
      setLoading(false);
    }, 500);

    return () => clearTimeout(delay);
  }, [email]);

  useEffect(() => {
    updateForm_IsAvailable();
  }, [email, isAvailable, isValid]);

  const handleChange = (e) => {
    setEmail(e.target.value);
    onChange({ target: { name: "email", value: e.target.value } });
  };

  const updateForm_IsAvailable = () => {
    if (email.length >= 4 && isAvailable === true && isValid === true) {
      onChange({ target: { name: "isEmailAvailable", value: true } });
    } else {
      onChange({ target: { name: "isEmailAvailable", value: false } });
    }
  }

  const isValidEmail = (email) => {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
  };

  return (
    <div>
      <label htmlFor="email" className="block text-sm font-medium text-gray-700">
        Email address
      </label>
      <div className="relative">
        <Mail className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400 w-5 h-5" />
        <input
          type="email"
          name="email"
          value={email}
          onChange={handleChange}
          className={`block w-full pl-10 pr-3 py-3 border rounded-lg shadow-sm placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-red-500 focus:border-transparent transition-all duration-200 ${email && !isValidEmail(email)
            ? 'border-red-300 bg-red-50'
            : 'border-gray-300 bg-white hover:border-gray-400'
            }`}
          placeholder="Enter your email"
          autoComplete="email"
          required
        />
        {loading ? (
          <div className="absolute right-3 top-1/2 transform -translate-y-1/2 text-gray-400">
            Checking...
          </div>
        ) : isValid && isAvailable !== null && (
          <div className="absolute right-3 top-1/2 transform -translate-y-1/2">
            {isAvailable ? (
              <CheckCircle className="text-green-500 w-5 h-5" />
            ) : (
              <XCircle className="text-red-500 w-5 h-5" />
            )}
          </div>
        )}
      </div>

      {!isValid && email.length > 0 && (
        <p className="text-red-500 text-sm mt-1">Invalid email format.</p>
      )}

      {isValid && isAvailable === false && (
        <p className="text-red-500 text-sm mt-1">
          This email is already in use. <a href="/login" className="text-amber-500 underline">Log in</a> instead?
        </p>
      )}
    </div>
  );
};


const PasswordFields = ({ formData, setFormData }) => {
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  // const [strengthInfo, setStrengthInfo] = useState("");
  const [passwordStrength, setPasswordStrength] = useState();

  // Determine password strength
  // const getPasswordStrength = (pass) => {
  //   if (pass.length < 6) return "Too short";
  //   if (pass.match(/[A-Z]/) && pass.match(/[0-9]/) && pass.match(/[@$!%*?&#]/)) {
  //     return "Strong";
  //   }
  //   if (pass.match(/[A-Z]/) || pass.match(/[0-9]/) || pass.match(/[@$!%*?&#]/)) {
  //     return "Medium";
  //   }
  //   return "Weak";
  // };

  // Handle password input changes
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));

    if (name === "password") {
      setPasswordStrength(getPasswordStrength(value));
    }
  };


  const getPasswordStrength = (password) => {
    let strength = 0;
    if (password.length >= 6) strength++;
    if (/[A-Z]/.test(password)) strength++;
    if (/[0-9]/.test(password)) strength++;
    if (/[^A-Za-z0-9]/.test(password)) strength++;
    return strength;
  };

  const getPasswordStrengthText = (strength) => {
    if (strength === 0) return { text: '', color: '' };
    if (strength === 1) return { text: 'Weak', color: 'text-red-600' };
    if (strength === 2) return { text: 'Fair', color: 'text-yellow-600' };
    if (strength === 3) return { text: 'Good', color: 'text-blue-600' };
    return { text: 'Strong', color: 'text-green-600' };
  };

  // const passwordStrength = getPasswordStrength(password);
  const strengthInfo = getPasswordStrengthText(passwordStrength);

  return (
    <div>
      {/* Password Field */}
      <div>
        <label htmlFor="password" className="block text-sm font-medium text-gray-700">
          Password
        </label>
        <div className="relative">
          <Lock className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400 w-5 h-5" />
          <input
            type={showPassword ? "text" : "password"}
            name="password"
            value={formData.password}
            onChange={handleChange}
            className="block w-full pl-10 pr-10 py-3 border border-gray-300 rounded-lg shadow-sm placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-red-500 focus:border-transparent bg-white hover:border-gray-400 transition-all duration-200"
            placeholder="Create a password"
            autoComplete="new-password"
            required
            minLength={6}
          />
          <button
            type="button"
            className="absolute right-3 top-1/2 transform -translate-y-1/2 text-gray-400 w-5 h-5"
            onClick={() => setShowPassword(!showPassword)}
          >
            {showPassword ? <EyeOff /> : <Eye />}
          </button>
        </div>
        {/* {formData.password && (
          <p
            className={`mt-2 text-sm ${strength === "Strong" ? "text-green-500" : strength === "Medium" ? "text-yellow-500" : "text-red-500"
              }`}
          >
            {strength}
          </p>
        )} */}
        {formData.password && (
          <div className="mt-2">
            <div className="flex items-center gap-2">
              <div className="flex-1 bg-gray-200 rounded-full h-1.5">
                <div
                  className={`h-1.5 rounded-full transition-all duration-300 ${passwordStrength === 1 ? 'w-1/4 bg-red-500' :
                    passwordStrength === 2 ? 'w-2/4 bg-yellow-500' :
                      passwordStrength === 3 ? 'w-3/4 bg-blue-500' :
                        passwordStrength === 4 ? 'w-full bg-green-500' : 'w-0'
                    }`}
                />
              </div>
              <span className={`text-xs font-medium ${strengthInfo.color}`}>
                {strengthInfo.text}
              </span>
            </div>
          </div>
        )}
      </div>



      {/* Confirm Password Field */}
      <div className="mt-4">
        <label htmlFor="confirmPassword" className="block text-sm font-medium text-gray-700">
          Confirm password
        </label>
        <div className="relative">
          <Lock className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400 w-5 h-5" />
          <input
            type={showConfirmPassword ? "text" : "password"}
            name="confirmPassword"
            value={formData.confirmPassword}
            onChange={handleChange}
            className={`block w-full pl-10 pr-10 py-3 border rounded-lg shadow-sm placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-red-500 focus:border-transparent transition-all duration-200 ${formData.confirmPassword && formData.password !== formData.confirmPassword
              ? 'border-red-300 bg-red-50'
              : 'border-gray-300 bg-white hover:border-gray-400'
              }`}
            placeholder="Confirm your password"
            autoComplete="new-password"
            required
          />
          <button
            type="button"
            className="absolute right-3 top-1/2 transform -translate-y-1/2 text-gray-400 w-5 h-5"
            onClick={() => setShowConfirmPassword(!showConfirmPassword)}
          >
            {showConfirmPassword ? <EyeOff /> : <Eye />}
          </button>
        </div>
        {formData.confirmPassword && (
          <p
            className={`mt-2 text-sm ${formData.password === formData.confirmPassword ? "text-green-500" : "text-red-500"
              }`}
          >
            {formData.password === formData.confirmPassword ? (
              <span className="flex items-center">
                <CheckCircle className="w-4 h-4 mr-1 text-green-500" />
                Passwords match
              </span>
            ) : (
              <span className="flex items-center">
                <XCircle className="w-4 h-4 mr-1 text-red-500" />
                Passwords do not match
              </span>
            )}
          </p>
        )}
      </div>
    </div>
  );
};



{/* <form className="space-y-6" onSubmit={handleSubmit}>
  {error && (
    <div className="flex items-center gap-2 p-4 bg-red-50 border border-red-200 rounded-lg text-red-700 text-sm">
      <AlertCircle className="h-4 w-4 flex-shrink-0" />
      <span>{error}</span>
    </div>
  )}


  <div className="space-y-1">
    <label htmlFor="name" className="block text-sm font-medium text-gray-700">
      Full name
    </label>
    <div className="relative">
      <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
        <User className="h-5 w-5 text-gray-400" />
      </div>
      <input
        id="name"
        type="text"
        value={name}
        onChange={(e) => setName(e.target.value)}
        className="block w-full pl-10 pr-3 py-3 border border-gray-300 rounded-lg shadow-sm placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-red-500 focus:border-transparent bg-white hover:border-gray-400 transition-all duration-200"
        placeholder="Enter your full name"
        autoComplete="name"
        disabled={loading}
      />
    </div>
  </div>


  <div className="space-y-1">
    <label htmlFor="email" className="block text-sm font-medium text-gray-700">
      Email address
    </label>
    <div className="relative">
      <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
        <Mail className="h-5 w-5 text-gray-400" />
      </div>
      <input
        id="email"
        type="email"
        value={email}
        onChange={(e) => setEmail(e.target.value)}
        className={`block w-full pl-10 pr-3 py-3 border rounded-lg shadow-sm placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-red-500 focus:border-transparent transition-all duration-200 ${email && !isValidEmail(email)
          ? 'border-red-300 bg-red-50'
          : 'border-gray-300 bg-white hover:border-gray-400'
          }`}
        placeholder="Enter your email"
        autoComplete="email"
        disabled={loading}
      />
    </div>
  </div>


  <div className="space-y-1">
    <label htmlFor="password" className="block text-sm font-medium text-gray-700">
      Password
    </label>
    <div className="relative">
      <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
        <Lock className="h-5 w-5 text-gray-400" />
      </div>
      <input
        id="password"
        type={showPassword ? 'text' : 'password'}
        value={password}
        onChange={(e) => setPassword(e.target.value)}
        className="block w-full pl-10 pr-10 py-3 border border-gray-300 rounded-lg shadow-sm placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-red-500 focus:border-transparent bg-white hover:border-gray-400 transition-all duration-200"
        placeholder="Create a password"
        autoComplete="new-password"
        disabled={loading}
      />
      <button
        type="button"
        onClick={() => setShowPassword(!showPassword)}
        className="absolute inset-y-0 right-0 pr-3 flex items-center text-gray-400 hover:text-gray-600 transition-colors"
        disabled={loading}
      >
        {showPassword ? (
          <EyeOff className="h-5 w-5" />
        ) : (
          <Eye className="h-5 w-5" />
        )}
      </button>
    </div>
    
    {password && (
      <div className="mt-2">
        <div className="flex items-center gap-2">
          <div className="flex-1 bg-gray-200 rounded-full h-1.5">
            <div
              className={`h-1.5 rounded-full transition-all duration-300 ${passwordStrength === 1 ? 'w-1/4 bg-red-500' :
                passwordStrength === 2 ? 'w-2/4 bg-yellow-500' :
                  passwordStrength === 3 ? 'w-3/4 bg-blue-500' :
                    passwordStrength === 4 ? 'w-full bg-green-500' : 'w-0'
                }`}
            />
          </div>
          <span className={`text-xs font-medium ${strengthInfo.color}`}>
            {strengthInfo.text}
          </span>
        </div>
      </div>
    )}
  </div>


  <div className="space-y-1">
    <label htmlFor="confirmPassword" className="block text-sm font-medium text-gray-700">
      Confirm password
    </label>
    <div className="relative">
      <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
        <Lock className="h-5 w-5 text-gray-400" />
      </div>
      <input
        id="confirmPassword"
        type={showConfirmPassword ? 'text' : 'password'}
        value={confirmPassword}
        onChange={(e) => setConfirmPassword(e.target.value)}
        className={`block w-full pl-10 pr-10 py-3 border rounded-lg shadow-sm placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-red-500 focus:border-transparent transition-all duration-200 ${confirmPassword && password !== confirmPassword
          ? 'border-red-300 bg-red-50'
          : 'border-gray-300 bg-white hover:border-gray-400'
          }`}
        placeholder="Confirm your password"
        autoComplete="new-password"
        disabled={loading}
      />
      <button
        type="button"
        onClick={() => setShowConfirmPassword(!showConfirmPassword)}
        className="absolute inset-y-0 right-0 pr-3 flex items-center text-gray-400 hover:text-gray-600 transition-colors"
        disabled={loading}
      >
        {showConfirmPassword ? (
          <EyeOff className="h-5 w-5" />
        ) : (
          <Eye className="h-5 w-5" />
        )}
      </button>
    </div>
    {confirmPassword && password !== confirmPassword && (
      <p className="text-xs text-red-600 mt-1">Passwords do not match</p>
    )}
  </div>


  <button
    type="submit"
    disabled={loading || !name || !email || !password || !confirmPassword || !isValidEmail(email) || password !== confirmPassword}
    className="w-full flex justify-center items-center py-3 px-4 border border-transparent rounded-lg shadow-sm text-sm font-semibold text-white bg-gradient-to-r from-red-600 to-pink-600 hover:from-red-700 hover:to-pink-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-red-500 disabled:opacity-50 disabled:cursor-not-allowed transition-all duration-200 transform hover:scale-[1.02] active:scale-[0.98]"
  >
    {loading ? (
      <>
        <Loader2 className="h-4 w-4 mr-2 animate-spin" />
        Creating account...
      </>
    ) : (
      <>
        <UserPlus className="h-4 w-4 mr-2" />
        Create account
      </>
    )}
  </button>


  <div className="relative">
    <div className="absolute inset-0 flex items-center">
      <div className="w-full border-t border-gray-300" />
    </div>
    <div className="relative flex justify-center text-sm">
      <span className="px-2 bg-white text-gray-500">or</span>
    </div>
  </div>


  <div className="text-center">
    <p className="text-sm text-gray-600">
      Already have an account?{' '}
      <a href="/login" className="font-medium text-red-600 hover:text-red-500 transition-colors">
        Sign in instead
      </a>
    </p>
  </div>
</form> */}